<template>
  <div class="ba7-collapse">
    <div class="collapse-top">
      <span v-text="title"></span>
      <button @click="opened = !opened" :class="{'opened': opened}">
        <builderall-icon code='5da4'></builderall-icon>
      </button>
    </div>
    <div v-if="opened" class="collapse-main">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TagsItem',
  props: ['title'],
  data() {
    return {
      opened: true
    }
  },
};
</script>

<style lang="scss" scoped>
.ba7-collapse {
  display: grid;
  gap: 16px;
  border-radius: 16px;
  border: 1px solid #D5DEE9CC;
  width: 100%;
  .collapse-top{
    display: flex;
    justify-content: space-between;
    border-radius: 16px;
    gap: 16px;
    align-items: center;
    padding: 22px;
    background-color: #F7F8FC;
    &:has(button.opened){
      border-radius: 16px 16px 0 0;
      border-bottom: 1px solid #D5DEE9CC;
    }
    span{
      color: #4D5D71;
      font-weight: bold;
      font-size: 14px;
    }
    button{
      background: transparent;
      border: none;
      outline: none;
      &.opened{
        builderall-icon{
          transform: rotate(180deg);
          transition: .4s;
        }
      }
      builderall-icon{
        --builderall-icon-size: 16px;
        --builderall-icon-color: #0072E1;
      }
    }
  }
  .collapse-main{
    padding: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/components/Collapse.vue